import React, { Component } from 'react';
import moment from 'moment';

import UrbioticaInfrastructureSettingsForm from './UrbioticaInfrastructureSettingsForm';

import { defaultSorter, dateSorter } from './Helpers';
import UrbioticaInfrastructuresModel from './UrbioticaInfrastructuresModel';
import UserModel from './UserModel';

import { Table, Badge, Row, Col, Card, Popconfirm, Divider, message, Typography } from 'antd';
import UrbioticaInfrastructuresAktualTechInfos from './UrbioticaInfrastructuresAktualTechInfos';

class UrbioticaInfrastructuresTable extends Component {

  state = {
    children: [],
    filteredInfo: {},
    sortedInfo: {},
    urbioticaInfrastructureSettingsFormData: null
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState({
      filteredInfo: filters,
      sortedInfo: sorter,
    });
  }

  expandedRowRender(record) {
    return (
      <div>
        <Row>
          <Col span={3}>
            <Card title="ElementID">
              {record.elementID}
            </Card>
          </Col>
          {!this.props.loading && <UrbioticaInfrastructuresAktualTechInfos infrastructureID={record.id} />}
        </Row>
      </div >
    );
  }

  render() {

    let { sortedInfo, filteredInfo } = this.state;

    const columns = [{
      title: 'Lokalita',
      dataIndex: 'parkingLocationName',
      key: 'parkingLocationName',
      width: 250,
      sorter: (a, b) => defaultSorter(a.parkingLocationName, b.parkingLocationName)
    }, {
      title: 'POM',
      dataIndex: 'pom',
      key: 'pom',
      width: 100,
      sorter: (a, b) => defaultSorter(a.pom, b.pom)
    }, {
      title: 'Typ zprávy',
      dataIndex: 'messageType',
      key: 'messageType',
      width: 70,
      filters: [{
        text: 'vehicle_ctrl',
        value: 'vehicle_ctrl',
      }, {
        text: 'vehicle',
        value: 'vehicle',
      }],
      onFilter: (value, record) => record.messageType === value,
    }, {
      title: 'Místo',
      dataIndex: 'placeID',
      key: 'placeID',
      width: 75,
      defaultSortOrder: 'ascend',
      sorter: (a, b) => defaultSorter(a.placeID, b.placeID),
      render: (text, record) => {
        if (record.productType == 'U-Spot') {
          return record.placeID
        } else {
          return '--'
        }
      }
    }, {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (text, record) => {
        if (record.occ == -1) {
          return "Down"
        } else {
          if (typeof (record.status) == 'undefined') {
            return "Up"
          } else {
            return record.status
          }
        }
      }
    }, {
      title: 'Typ',
      dataIndex: 'productType',
      key: 'productType'
    }, {
      title: 'Poslední změna stavu',
      dataIndex: 'lastStateChange',
      key: 'lastStateChange',
      width: 185,
      sorter: (a, b) => dateSorter(a.lastStateChange, b.lastStateChange),
      render: (text, record) => {
        if (record.productType == 'U-Spot') {
          return (moment(record.lastStateChange).format('L LTS'))
        } else {
          return '--'
        }
      }
    }, {
      title: 'Stav',
      dataIndex: 'occ',
      key: 'occ',
      width: 150,
      filters: [{
        text: 'OBSAZENO',
        value: 1,
      }, {
        text: 'VOLNO',
        value: 0,
      }, {
        text: 'Kalibrace / neznámý stav / chyba',
        value: -1,
      }],
      filteredValue: filteredInfo.occ || null,
      onFilter: (value, record) => { return (parseInt(record.occ) === parseInt(value)) ? true : false },
      sorter: (a, b) => defaultSorter(a.occ, b.occ),
      render: (text, record) => {
        if (record.occ === 1 && record.productType == 'U-Spot') {
          return (
            <Badge
              status="error"
              text={"OBSAZENO"}
              title="Obsazeno" />
          );
        } else if (record.occ === 0 && record.productType == 'U-Spot') {
          return (
            <Badge
              status="success"
              text={"VOLNO"}
              title="Volno" />
          );
        } else if (record.productType == 'U-Spot') {
          return (
            <Badge
              color="#6d6d6d"
              text={"Kalibrace / neznámý stav / chyba"}
              title="Kalibrace / neznámý stav / chyba" />
          )
        } else {
          return '--'
        }
      }
    }, {
      title: 'Upozornění',
      dataIndex: 'reportsEnabled',
      key: 'reportsEnabled',
      width: 130,
      filters: [{
        text: 'ZAPNUTO',
        value: true,
      }, {
        text: 'VYPNUTO',
        value: false,
      }],
      filteredValue: filteredInfo.reportsEnabled || null,
      onFilter: (value, record) => {
        return ((record.reportsEnabled === value)) ? true : false
      },
      render: (text, record) => {
        if (record.reportsEnabled === true) {
          return (
            <Badge
              status="success"
              text="ZAPNUTO" />
          );
        } else {
          return (
            <Badge
              status="error"
              text="VYPNUTO" />
          );
        }
      }
    }, {
      title: 'Akce',
      key: 'Action',
      width: 200,
      render: (text, record) => {
        if (UserModel.isInRoles(['ADMIN', 'URBIOTICA_INFRASTRUCTURES_WRITE'])) {
          return (
            <div>
              <a onClick={(e) => {
                this.setState({
                  urbioticaInfrastructureSettingsFormData: record
                });
              }}>Nastavení</a>
              <Divider type="vertical" />
              <Popconfirm placement="right" title="Opravdu si přejete záznam smazat?" onConfirm={() => {
                this.props.onRemoveRow
                  ? this.props.onRemoveRow(record.id)
                  : null;
              }} okText="Ano" cancelText="Ne">
                <a onClick={(e) => { e.preventDefault(); }}><Typography.Text type="danger">Smazat</Typography.Text></a>
              </Popconfirm>
            </div>
          );
        }
      }
    }];

    return (
      <div>
        <Table
          size='small'
          rowKey={this.props.rowKey ? this.props.rowKey : 'id'}
          loading={this.props.loading ? this.props.loading : false}
          columns={columns}
          dataSource={this.props.data}
          onChange={this.handleChange}
          pagination={{
            showSizeChanger: true,
            defaultPageSize: localStorage.getItem('table_pageSize') !== undefined
              ? parseInt(localStorage.getItem('table_pageSize'))
              : 10,
            onShowSizeChange: (current, size) => {
              localStorage.setItem('table_pageSize', size);
            }
          }}
          expandedRowRender={this.expandedRowRender.bind(this)}
          style={{ border: '0px' }} />
        <UrbioticaInfrastructureSettingsForm
          type="modal"
          modalVisible={this.state.urbioticaInfrastructureSettingsFormData === null ? false : true}
          initialValues={this.state.urbioticaInfrastructureSettingsFormData}
          onModalCancel={(form) => {
            form.resetFields();
            this.setState({ urbioticaInfrastructureSettingsFormData: null });
          }}
          onSuccess={(form, values) => {
            UrbioticaInfrastructuresModel.patch(this.state.urbioticaInfrastructureSettingsFormData.id, values)
              .then(() => {
                message.success("Změna byla uložena!");
                form.resetFields();
                this.setState({
                  urbioticaInfrastructureSettingsFormData: null
                });
                if (this.props.onAnyFormSuccess) {
                  this.props.onAnyFormSuccess();
                }
              })
              .catch(err => {
                message.warning('Změnu se nepodařilo uložit. Zkontrolujte spravnou funkčnost služby.');
              })
          }} />
      </div>
    );
  }
}

export default UrbioticaInfrastructuresTable;


// WEBPACK FOOTER //
// ./src/components/UrbioticaInfrastructuresTable.js